// extracted by mini-css-extract-plugin
export default {"confirmMsg":"_5ZtUfI","joinButtons":"_2cLtmW","loginButtons":"_1LQFEZ"};